import { ReactNode } from 'react';

export const EntityDataLockerContainer = ({ children }: { children: ReactNode }) => (
  <div className="bg-canvas-tertiary-main h-full">{children}</div>
);
